const BaseView = require('./view');
const $window = $(window);
const noVerticalScrollClass = 'od-viewport-no-vertical-scroll';
let currentScrollTop = 0;

module.exports = BaseView.extend({
    childLayerOpenedClass: 'opened',
    childContainerTitleClass: Odigeo.AB.isCssVariationMobile ? 'odf-text-2lg' : 'odf-text-2xl',

    initialize() {
        BaseView.prototype.initialize.apply(this, arguments);

        this.historyBackCallback = this.onHistoryBack.bind(this);
    },

    onOpen() {
        BaseView.prototype.onOpen.apply(this, arguments);
        this.toggleHistoryListener(true);
    },

    onConfirm(e) {
        e.preventDefault();
        e.stopPropagation();

        this.toggleHint();
        this.track('onConfirm');
        this.toggleChildLayer(false);
    },

    toggleHint() {
        const {isSelected} = this.model.getProduct();
        if (isSelected) {
            Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), $('.fee_bags_tooltip_hint'), {
                events: {
                    tap: true,
                },
            });
        }
    },

    toggleChildLayer(show, backWithHistory = true) {
        BaseView.prototype.toggleChildLayer.apply(this, arguments);
        if (!show) {
            this.toggleHistoryListener(false);

            if (backWithHistory) {
                Odigeo.History.history.back();
            }
        }

        this.toggleMainPageScroll(show);
    },

    toggleHistoryListener(enable) {
        if (enable) {
            Odigeo.History.history.pushState({}, null, null);
            window.addEventListener('popstate', this.historyBackCallback);
        } else {
            window.removeEventListener('popstate', this.historyBackCallback);
        }
    },

    onHistoryBack() {
        this.toggleChildLayer(false, false);
    },

    toggleMainPageScroll(isDisabling) {
        if (isDisabling) {
            Odigeo._.delay(() => {
                this.onFixMainLayout();
            }, 300);
        } else {
            this.onRestoreMainLayout();
        }
    },

    onFixMainLayout() {
        currentScrollTop = $window.scrollTop();
        Odigeo.Device.getViewport().toggleClass(noVerticalScrollClass, true);
    },

    onRestoreMainLayout() {
        Odigeo.Device.getViewport().toggleClass(noVerticalScrollClass, false);
        $window.scrollTop(currentScrollTop);
    },

});
